import Controller from "@ember/controller";
import { task } from "ember-concurrency";
import { tracked } from "@glimmer/tracking";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";

export default class extends Controller {
  @service ajax;

  @tracked showSuccess = false;
  @tracked email;

  onChange = ({ email }) => (this.email = email);

  submitEmail = task(async () => {
    await this.ajax.post(`${ENV.apiBaseUri}/recovery/create`, { data: { email: this.email } });
    this.showSuccess = true;
  });
}
